import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faDeleteLeft } from '@fortawesome/free-solid-svg-icons';
import ClipboardTool from '../ClipboardTool/ClipboardTool';

interface SegmentListProps {
  segmentLabels: GeoJSON.Feature<GeoJSON.Point>[];
  trashLastSegment: () => void;
  trashAllSegments: () => void;
}
const SegmentList: React.FC<SegmentListProps> = ({ segmentLabels, trashLastSegment, trashAllSegments }) => {
  const labelsString = segmentLabels.map(point => point.properties?.label).join('\n');

  return (
    <div className="segment-list-container">
      <div className="segment-list-actions">
        <button
          type="button"
          className="segment-action-btn segment-action-btn--danger"
          onClick={trashLastSegment}
          title="Delete the most recent segment"
        >
          <FontAwesomeIcon icon={faDeleteLeft} />
          <span>Delete last</span>
        </button>
        <button
          type="button"
          className="segment-action-btn segment-action-btn--danger"
          onClick={trashAllSegments}
          title="Delete every segment"
        >
          <FontAwesomeIcon icon={faTrashCan} />
          <span>Delete all</span>
        </button>
      </div>

      {segmentLabels.length > 0 && (
        <div className="segment-list-copy-row">
          <span>Copy all segments</span>
          <ClipboardTool textToCopy={labelsString} />
        </div>
      )}

      <ul id="segment-list">
        {segmentLabels.map((point, index) => (
          <li key={index}>{point.properties?.label}</li>
        ))}
      </ul>
    </div>
  );
};

export default SegmentList;

